Librarian.GroupSelectWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["onGroupMembersLoaded"],

    options: {
        id: "GroupSelectWindow",
        title: "groupselect_title",
        groupName: null,
        width: 300,
        height: 80,
        enableComments: false,
        canChooseGroup: true,
        noDefault: false
    },

    request: null,

    initialize: function(options) {
        this.setOptions(options);

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString(options.title);

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/groupselect.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        this.request = Librarian.Utils.getUserGroupInfo(this.options.groupName, true, this.onGroupMembersLoaded);

        var buttonEl = this.getElement("cancelButton");
        if (buttonEl)
            buttonEl.addOnClick(this.close);

        buttonEl = this.getElement("assignButton");
        if (buttonEl) {
            buttonEl.addOnClick(function() {
                var selectEl = this.getElement("groupSelect"),
                    selected = Librarian.Utils.getSelectedValue(selectEl),
                    selectedName = Librarian.Utils.getSelectedItem(selectEl).text,
                    comment = null;

                if (selected === "-1") {
                    Librarian.Utils.notification(Librarian.Lang.getString("groupselect_no_select"));
                    return;
                }

                // Get comments from text area if option is enabled
                if (this.options.enableComments) {
                    var commentEl = this.getElement("groupSelectCommentTextArea");
                    comment = (Librarian.Utils.getElementValue(commentEl) || '').trim();

                    if (comment && (comment.length > 0))
                        comment = comment.stripTags().trim();
                }

                this.fireEvent("userSelected", [selected, comment, this.options.canChooseGroup && selectEl && (selectEl.selectedIndex == 0), selectedName]);
                this.close();
            }.bind(this));
        }

        if (this.options.enableComments)
            this.getElement("groupSelectWorkflowComment").show();
    },

    onClose: function() {
        if (this.request) {
            this.request.cancel();
            this.request = null;
        }
    },

    onGroupMembersLoaded: function(data) {
        var selectEl = this.getElement("groupSelect");
        if (selectEl) {
            if (this.options.noDefault) {
                selectEl.options.add(new Option("-", -1));
            }

            if (this.options.canChooseGroup)
                selectEl.options.add(new Option(data.name, data.groupId));

            var getName = function(member) {
                    if (!member.isGroup)
                        return member.displayName;
                    return member.groupName;
                },
                members = data.members;

            // Sort the list by name
            members.sort(function(a, b) {
                var aName = getName(a),
                    bName = getName(b);
                return (aName < bName) ? -1 : ((aName > bName) ? 1 : 0);
            });

            for (var i = 0, length = members.length; i < length; i++) {
                var name = getName(members[i]);
                selectEl.options.add(new Option(name, members[i].userId));
            }
        }
    }
})